<template>
  <el-container v-title data-title="发送记录" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>通知发送</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="班级">
                  <el-select v-model="searchForm.classId">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in selectingClassList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学生姓名">
                  <el-input v-model="searchForm.realName" placeholder="学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="发送类型" prop="sendType">
                  <el-select v-model="searchForm.sendType" placeholder="请选择发送类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="微信" value="1"></el-option>
                    <el-option label="短信" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="发送状态" prop="status">
                  <el-select v-model="searchForm.status" placeholder="请选择发送状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="成功" value="1"></el-option>
                    <el-option label="失败" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getNotifySendList">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="insertTime" label="时间" width="165"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="50"></el-table-column>
          <!-- <el-table-column prop="notifyContent" label="通知内容" width="200"></el-table-column> -->
          <el-table-column prop="notifyTypeName" label="通知类型" width="80"></el-table-column>
          <el-table-column prop="sendTypeName" label="发送类型" width="80"></el-table-column>
          <el-table-column prop="relationUserRealName" label="关联人姓名" width="80"></el-table-column>
          <el-table-column prop="schoolName" label="学校" width="160"></el-table-column>
          <el-table-column prop="className" label="班级" width="85"></el-table-column>
          <el-table-column prop="relationUserRealName" label="关联人姓名" width="100"></el-table-column>
          <el-table-column prop="receiverRealName" label="接收人姓名" width="91"></el-table-column>
          <el-table-column prop="content" label="内容" width="200"></el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getNotifySendList"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pageSizes"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        schoolId: '',
        classId: '',
        sendType: '',
        status: ''
      },
      schoolList: [],
      classList: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getNotifySendList()
      this.getSchoolList()
      this.getClassList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getNotifySendList()
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getClassList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/class/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.classList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getNotifySendList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/messageSendRecord/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          messageType: 2,
          schoolId: _this.searchForm.schoolId,
          classId: _this.searchForm.classId,
          realName: _this.searchForm.realName,
          sendType: _this.searchForm.sendType,
          status: _this.searchForm.status,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    }
  },
  computed: {
    selectingClassList () {
      let tempArray = []
      if (this.searchForm.schoolId != null && this.searchForm.schoolId !== '') {
        this.classList.forEach(classInfo => {
          if (classInfo.schoolId === this.searchForm.schoolId) {
            tempArray.push(classInfo)
          }
        })
      } else {
        tempArray = this.classList
      }
      return tempArray
    }
  },
  watch: {
    selectingClassList () {
      if (this.searchForm.classId != null && this.searchForm.schoolId !== '' && this.selectingClassList.map(item => item.id).indexOf(this.searchForm.classId) === -1) {
        this.searchForm.classId = ''
      }
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/MessageSendForNotify.vue